import { useMemo } from 'react';
import { useInstagramUserImages } from '@round/platforms/instagram';
import { useTikTokUserImages } from '@round/platforms/tiktok';
import { getUserImage } from 'Modules/Plans/CreatorSearch/utils/creatorSearchImageUtils';

type Args = {
    userId: number | undefined;
    platform: 'tiktok' | 'instagram';
};

export default function useSourceAccountImage({ userId, platform }: Args) {
    const ids = typeof userId === 'number' ? [userId] : [];
    const tiktok = useTikTokUserImages(ids, {
        enabled: platform === 'tiktok' && ids.length > 0,
    });
    const instagram = useInstagramUserImages(ids, {
        enabled: platform === 'instagram' && ids.length > 0,
    });

    const image = useMemo(() => {
        if (typeof userId !== 'number') return null;
        return getUserImage(userId, tiktok.data ?? [], instagram.data ?? []);
    }, [userId, tiktok.data, instagram.data]);

    return {
        image,
        isLoading: tiktok.isLoading || instagram.isLoading,
    };
}
